<template>
  <v-dialog :modelValue="show" max-width="506" persistent @update:modelValue="$emit('update:show', $event)">
    <v-card style="position: relative">
      <PreUnenrollment
        v-if="!successfulUnenrolled"
        :courseInfo="courseInfoCached"
        @doCourseUnenroll="doCourseUnenroll"
        @closeDialog="closeDialog"
        @isSuccessfulUnenroll="isSuccessfulUnenroll"
        :isEMVerified="isEMVerified"
        :isRefundEligible="isRefundEligible"
        :paymentMethod="paymentMethod"
        :buttonAction="buttonAction"
        :enrollmentMode="enrollmentMode"
        :isCourseRefunded="isCourseRefunded"
        :verifiedTransactionId="verifiedTransactionId"
      />

      <PostUnenrollment
        v-if="successfulUnenrolled && from !== 'pathways'"
        @closeDialog="closeDialog"
        :enrollmentId="enrollmentIdCached"
        @isSuccessfulUnenroll="isSuccessfulUnenroll"
        :isEMVerified="isEMVerified"
        :isRefundEligible="false"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue';

import PreUnenrollment from './PreUnenrollment.vue';
import PostUnenrollment from './PostUnenrollment.vue';
import { Logger } from '../mixins/logger';
import { AjaxLoader } from '../mixins/ajaxLoader';
import { Helper } from '../mixins/helpers.js';
export default defineComponent({
  emits: ['update:show', 'openCloseUnenrollModel', 'doUnenroll'],
  name: 'UnenrollDialog',

  components: {
    PreUnenrollment,
    PostUnenrollment
  },

  mixins: [AjaxLoader, Logger, Helper],

  data() {
    return {
      successfulUnenrolled: false
    };
  },

  props: {
    show: Boolean,
    courseInfo: Object,
    paymentMethod: String,
    enrollmentModeVerifiedDate: String,
    enrollmentId: String,
    courseDropDeadline: Number,
    buttonAction: String,
    enrollmentMode: String,
    from: String,
    isCourseRefunded: Boolean,
    verifiedTransactionId: String
  },

  methods: {
    closeDialog() {
      this.$emit('openCloseUnenrollModel');
    },

    doCourseUnenroll() {
      this.$emit('doUnenroll', {
        enrollmentId: this.enrollmentIdCached,
        callback: () => {
          this.isSuccessfulUnenroll();
        }
      });
    },

    isSuccessfulUnenroll() {
      if (this.buttonAction !== 'Enroll and pay' && this.enrollmentMode !== 'honor') {
        this.successfulUnenrolled = !this.successfulUnenrolled;
      }
    },

    checkCourseType(courseType) {
      return ((this.courseInfoCached || {})._courseType || '').toLowerCase() === courseType;
    }
  },

  computed: {
    isRefundEligible() {
      return Helper.methods.isEligibleForRefund(this.courseInfo);
    },
    paymentMethodCached() {
      return this.paymentMethod;
    },

    enrollmentIdCached() {
      return this.enrollmentId;
    },

    enrollmentModeCached() {
      return (this.courseInfo || {})._enrollmentMode || '';
    },

    courseInfoCached() {
      return this.courseInfo;
    },

    checkCourseStartDateInFuture() {
      return parseInt(this.calculateAge(this.courseInfoCached._courseStartDate)) < 0;
    },

    isEMVerified() {
      return this.enrollmentModeCached.toLowerCase() === 'verified';
    }
  }
});
</script>
